// extracted by mini-css-extract-plugin
export default {"back":"Sj_HZ"};